const NotFound: React.FC = () => (
  <main className="notfound">
    <div className="wrap">
      <div className="eyebrow">404</div>
      <h2>This page doesn't exist.</h2>
      <a className="mail" href="/">
        Back to home
      </a>
    </div>
  </main>
);

export default NotFound;
